// The schedules and their effective dates come from the authenticated backend.
export function createDepartmentHoursClassifier(configuration) {
    const versions = [...(configuration?.versions || [])].sort((a, b) => a.effectiveFrom.localeCompare(b.effectiveFrom));
    const formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: configuration?.timezone || "Europe/Paris",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23"
    });

    return (department, utc) => {
        const normalized = typeof utc === "string" ? utc.replace(" ", "T") : "";
        const date = new Date(normalized && !/(Z|[+-]\d{2}:?\d{2})$/i.test(normalized) ? `${normalized}Z` : normalized);
        if (Number.isNaN(date.getTime())) {
            return { bucket: "outside", reason: "Date indisponible" };
        }
        const parts = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
        const day = `${parts.year}-${parts.month}-${parts.day}`;
        const time = `${parts.hour}:${parts.minute}`;
        const localDateTime = `${day} ${time}:${parts.second}`;
        const version = versions.filter(entry => entry.effectiveFrom <= day).at(-1);
        const schedule = version?.departments?.[department.trim()];
        const result = (bucket, reason) => ({ bucket, reason, localDateTime });
        if (!schedule) return result("inside", "Sans restriction horaire");

        const weekday = new Date(`${day}T00:00:00Z`).getUTCDay() || 7;
        const slots = schedule[weekday] || [];
        if (!slots.length) return result("outside", "Jour ferme");
        if (slots.some(([start, end]) => time >= start && time < end)) {
            return result("inside", "Pendant les horaires");
        }
        return result("outside", time < slots[0][0] ? "Avant ouverture" : time >= slots.at(-1)[1] ? "Apres fermeture" : "Entre deux plages");
    };
}
